/**
 * Short-lived server token for aggregate SSE (see backend /dashboard/stream-gate).
 * Cached until near expiry to avoid an extra request on every stream start.
 */

let cache = {
  token: '',
  /** ms epoch when token should be refreshed */
  refreshAtMs: 0,
  /** true once server responded gate_disabled */
  disabled: false,
  /** no successful fetch yet */
  primed: false,
};

function baseTrim(b) {
  return String(b || '').replace(/\/+$/, '');
}

/**
 * @param {string} baseUrl API root e.g. https://host/api
 * @returns {Promise<string>} token or "" when gate is off
 */
export async function ensureStreamGateToken(baseUrl) {
  const b = baseTrim(baseUrl);
  const now = Date.now();
  if (cache.disabled) return '';
  if (cache.primed && cache.token && now < cache.refreshAtMs) {
    return cache.token;
  }

  const res = await fetch(`${b}/dashboard/stream-gate`, { credentials: 'same-origin' });
  if (!res.ok) {
    throw new Error(`stream-gate HTTP ${res.status}`);
  }
  const data = await res.json().catch(() => ({}));
  cache.primed = true;
  if (data.gate_disabled) {
    cache.disabled = true;
    cache.token = '';
    cache.refreshAtMs = Number.MAX_SAFE_INTEGER;
    return '';
  }
  const tok = String(data.stream_gate || '').trim();
  const exp = Number(data.expires_in) || 900;
  cache.disabled = false;
  cache.token = tok;
  cache.refreshAtMs = now + Math.max(60_000, exp * 1000 - 60_000);
  return tok;
}

/** Call after 403 on stream to force a fresh token on next start. */
export function invalidateStreamGateCache() {
  cache = { token: '', refreshAtMs: 0, disabled: false, primed: false };
}
